/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiSelect } from '@elastic/eui'

import PrivacySensitiveContainer from '@modules/cui/PrivacySensitiveContainer'

import type { ProxyRequestMethod } from '../types'

const METHODS: ProxyRequestMethod[] = ['GET', 'POST', 'PUT', 'DELETE']

type Props = {
  value: ProxyRequestMethod
  onChange: (value: ProxyRequestMethod) => void
  disabled?: boolean
}

const ApiConsoleMethod: React.FunctionComponent<Props> = ({ value, onChange, disabled }) => {
  const { formatMessage } = useIntl()

  const options = METHODS.map((method) => ({ value: method, text: method, disabled }))

  return (
    <PrivacySensitiveContainer>
      <EuiSelect
        aria-label={formatMessage({
          id: 'apiConsole.methodLabel',
          defaultMessage: 'Method',
        })}
        options={options}
        value={value}
        onChange={(e) => {
          onChange(e.target.value as ProxyRequestMethod)
        }}
        disabled={disabled}
      />
    </PrivacySensitiveContainer>
  )
}

export default ApiConsoleMethod
